<svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
<g clip-path="url(#clip0_6454_61444)">
<path d="M7.00033 9.33464V7.0013M7.00033 4.66797H7.00616M12.8337 7.0013C12.8337 10.223 10.222 12.8346 7.00033 12.8346C3.77866 12.8346 1.16699 10.223 1.16699 7.0013C1.16699 3.77964 3.77866 1.16797 7.00033 1.16797C10.222 1.16797 12.8337 3.77964 12.8337 7.0013Z" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
</g>
<defs>
<clipPath id="clip0_6454_61444">
<rect width="14" height="14" fill="white"/>
</clipPath>
</defs>
</svg>
